import React, { useState } from "react"
import WPImage from "./_base/WPImage"
import { ChildSelector } from "../helpers/ChildSelector"
import * as expandableStyles from "../styles/ExpandableContent.module.css"

export default function ExpandableContent(props) {
  const [isExpanded, setIsExpanded] = useState(false)
  const { content } = props

  // Main content selectors
  const mainTitle = ChildSelector.select(
    content,
    "expandable-main-title",
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const firstSectionTitle = ChildSelector.select(
    content,
    "first-section-title",
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const firstSectionContent = ChildSelector.select(
    content,
    "first-section-content",
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const secondSectionTitle = ChildSelector.select(
    content,
    "second-section-title",
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const secondSectionList = ChildSelector.select(
    content,
    "second-section-list",
    ChildSelector.SELECTOR_TYPE.ARRAY,
  )

  const thirdSectionTitle = ChildSelector.select(
    content,
    "third-section-title",
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const thirdSectionList = ChildSelector.select(
    content,
    "third-section-list",
    ChildSelector.SELECTOR_TYPE.ARRAY,
  )

  const shareSectionTitle = ChildSelector.select(
    content,
    "share-section-title",
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const shareSectionList = ChildSelector.select(
    content,
    "share-section-list",
    ChildSelector.SELECTOR_TYPE.ARRAY,
  )

  const shareBadges = ChildSelector.select(
    content,
    "share-badges",
    ChildSelector.SELECTOR_TYPE.ARRAY,
  )

  function toggleExpand() {
    setIsExpanded(!isExpanded)
  }

  return (
    <div
      className={`${expandableStyles.expandableContainer} ${
        props.className || ""
      }`}
    >
      <div className={expandableStyles.header} onClick={toggleExpand}>
        <h1
          className={expandableStyles.mainTitle}
          dangerouslySetInnerHTML={{ __html: mainTitle }}
        />
        <span
          className={`${expandableStyles.arrow} ${
            isExpanded ? expandableStyles.expanded : ""
          }`}
        >
          {isExpanded ? "▼" : "▶"}
        </span>
      </div>

      {isExpanded && (
        <div className={expandableStyles.content}>
          <div className={expandableStyles.firstSection}>
            <h3
              className={expandableStyles.firstSectionTitle}
              dangerouslySetInnerHTML={{ __html: firstSectionTitle }}
            />
            <p
              className={expandableStyles.firstSectionContent}
              dangerouslySetInnerHTML={{ __html: firstSectionContent }}
            />
          </div>

          <div className={expandableStyles.section}>
            <h3
              className={expandableStyles.sectionTitle}
              dangerouslySetInnerHTML={{ __html: secondSectionTitle }}
            />
            <ul className={expandableStyles.sectionList}>
              {secondSectionList &&
                secondSectionList.map((item, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
            </ul>
          </div>

          <div className={expandableStyles.section}>
            <h3
              className={expandableStyles.sectionTitle}
              dangerouslySetInnerHTML={{ __html: thirdSectionTitle }}
            />
            <ul className={expandableStyles.wordList}>
              {thirdSectionList &&
                thirdSectionList.map((word, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: word }} />
                ))}
            </ul>
          </div>

          <div className={expandableStyles.section}>
            <h3
              className={expandableStyles.sectionTitle}
              dangerouslySetInnerHTML={{ __html: shareSectionTitle }}
            />
            <div className={expandableStyles.shareSectionWrapper}>
              <ul className={expandableStyles.sectionList}>
                {shareSectionList &&
                  shareSectionList.map((item, index) => (
                    <li
                      key={index}
                      dangerouslySetInnerHTML={{ __html: item }}
                    />
                  ))}
              </ul>
              <div className={expandableStyles.badgeContainer}>
                {shareBadges &&
                  shareBadges.map((badge, index) => (
                    <WPImage
                      holder={{ childNodes: [badge] }}
                      key={index}
                      alt={badge.alt}
                      selector={`share-badges`}
                      className={expandableStyles.badgeImage}
                    />
                  ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
